import React from 'react';
import { Table as AntTable } from 'antd';
import type { TableProps } from 'antd';
import clsx from 'clsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Table = <RecordType extends object = any>({
  className,
  ...props
}: TableProps<RecordType>) => (
  <AntTable<RecordType> {...props} className={clsx('wk-table', className)} />
);

Table.Column = AntTable.Column;
Table.ColumnGroup = AntTable.ColumnGroup;
Table.Summary = AntTable.Summary;
Table.SELECTION_ALL = AntTable.SELECTION_ALL;
Table.SELECTION_INVERT = AntTable.SELECTION_INVERT;
Table.SELECTION_NONE = AntTable.SELECTION_NONE;
Table.SELECTION_COLUMN = AntTable.SELECTION_COLUMN;
Table.EXPAND_COLUMN = AntTable.EXPAND_COLUMN;
